import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { DeliveryCompany } from "../../deliveryCompanies.types";
import { requestUpdateDeliveryCompany } from "./updateDeliveryCompany.request";

const useUpdateDeliveryCompany = (
  options?: MutationOptions<DeliveryCompany, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateDeliveryCompany,
    ...options
  });
};

export default useUpdateDeliveryCompany;
